import { useState, useEffect } from 'react';
import { Box, Typography, Avatar, IconButton, List, useMediaQuery, MenuItem, Grid } from '@mui/material';
import {
  ChevronRightOutlined,
  EmailOutlined,
  Logout,
  Phone,
} from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { deleteRegisterNotificationToken } from '../../screen/distributor/action/util_action';
import { logoutAction, updateTokenAction } from '../../v2/Onboarding/auth/action';
import DeliveryLocationCard from '../../v2/Address/Screens/DeliveryLocationCard';
import { addressDetailAction } from '../../v2/Address/APIs/action';
import { getCompanySuppliersAction } from '../../v2/BCMOrder/Action';
import IconReusable from '../../components/IconReusable';
import { CustomSelect } from '../../v2/MUI_custom_component';
import { decodeToken } from '../../utils/settings';
import { toast } from 'react-toastify';
import Entity from '../Common/Entity';
import { resetEntityState, fetchSuppliers } from '../Common/Entity/actions/reduxActions';

const Profile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loginUser, is_PWA } = useSelector((state) => {
    return {
      loginUser: state.loginReducer.loginUser,
      is_PWA: state.loginReducer.is_PWA,
    };
  });
  const [addressDetails, setAddressDetails] = useState(null);
  const [companyEsiId, setCompanyEsiId] = useState(null);

  const handleSetDeliveryLocation = () => {
    // setLocationPermissionModalOpen(true);
  };

  const fetchAddressDetails = async (company_esi_id) => {
    setAddressDetails(null);
    try {
      const response = await addressDetailAction(company_esi_id);

      if (!response?.error && response?.data && response?.data?.length) {
        setAddressDetails(response?.data[0]);
      }
    } catch (error) {
      console.error('Error fetching address details:', error);
    }
  };

  //Suppliers is called only for Dalmia (PWA) as at the moment Address feature is not clear for Entity in Humbee System
  const getSuppliers = async () => {
    const { error, data, message } = await getCompanySuppliersAction();

    if (!error) {
      const company_esi_id = data[0].suppliers_list[0]?.entity_info[0]?.esi_id;

      setCompanyEsiId(company_esi_id);
    }
  };

  useEffect(() => {
    if (is_PWA) {
      getSuppliers();
    }
  }, [is_PWA]);

  const handleAddressSaving = () => {
    getSuppliers();
    fetchAddressDetails(companyEsiId);
    
  }

  useEffect(() => {
    if (companyEsiId) {
      fetchAddressDetails(companyEsiId);
    }
  }, [companyEsiId]);

  const handleLogout = async () => {
    const userToken = JSON.parse(localStorage.getItem('message_token'));
    await deleteRegisterNotificationToken(userToken);
    await logoutAction();
    localStorage.clear();
    dispatch({ type: 'LOGOUT' });
    navigate('/');
  };
  const sections = [
    {
      title: 'Business Overview',
      items: [
        { label: 'Firms', path: '/my-account/firm-details', visible: !is_PWA },
        {
          label: 'Staff',
          path: '/my-account/employee-details',
          visible: !is_PWA,
        },
      ],
      visible: !is_PWA,
    },
    {
      title: 'Profiler',
      items: [
        {
          label: 'Bussiness Profiler',
          path: '/my-account/business-profiler',
          visible: true,
        },
        {
          label: 'Know your Business',
          path: '/my-account/know-you-better',
          visible: true,
        },
      ],
      visible: !is_PWA,
    },
    {
      title: 'Settings',
      items: [
        {
          label: 'Change Password',
          path: '/my-account/change-credentials',
          visible: !is_PWA,
        },
        {
          label: 'Change Phone',
          path: '/my-account/change-credentials',
          visible: !is_PWA,
        },
      ],
      visible: !is_PWA,
    },
    {
      title: 'Help',
      items: [
        {
          label: 'Contact Us',
          path: '/my-account/contact-us-and-policies',
          visible: true,
        },
        {
          label: 'FAQs',
          path: is_PWA ? '/pwa-faq' : '/my-account/faq',
          visible: true,
        },
      ],
      visible: true,
    },
  ];
  const visibleSections = sections.filter((section) => section.visible);
  const [selectedCompany, setSelectedCompany] = useState('');
  const [loading, setLoading] = useState(false);
  const isMobile = useMediaQuery('(max-width:1279px)');
  const [decodedData, setDecodedData] = useState({});
  useEffect(() => {
    const getTokenData = async () => {
      const decoded = await decodeToken();
      setDecodedData(decoded);
      setSelectedCompany(decoded?.default_company_info?.company_id);
    };
    getTokenData();
  }, []);
  useEffect(() => {
    if (loginUser && !is_PWA && isMobile) {
      dispatch(fetchSuppliers());
    }
  }, [loginUser, is_PWA]); 

  const handleCompanyChange = async (event) => {
    setLoading(true);
    const { data, error, message } = await updateTokenAction({ company_id: event.target.value });
    setTimeout(() => setLoading(false), 500);
    if (!error) {
      setSelectedCompany(event.target.value);
      localStorage.setItem('token', data);
      dispatch(resetEntityState());
      setTimeout(() => {
        dispatch(fetchSuppliers());
      }, 100);
    } else {
      toast.error(message);
    }
  };
  const { selectedSupplier: selectedManufacturer, selectedEntity: selectedCompanyEntity } = useSelector(
    (state) => state.entityReducer
  );

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <Box
        sx={{
          p: 3,
          mb: 3,
          borderRadius: 2,
          boxShadow: 'none',
          background: '#fff',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            {/* <CircularProgress
                            variant="determinate"
                            value={100}
                            size={80}
                            thickness={3}
                            sx={{
                                color: "#F7F7F7", // grey track
                                position: "absolute",
                                left: "-17%",
                                top: "-17%",
                                transform: "translate(-50%, -50%) rotate(-90deg)", // align with top
                            }}
                        />
                        <CircularProgress
                            variant="determinate"
                            value={75}
                            size={80}
                            thickness={3}
                            sx={{
                                color: "#008000", // green progress
                                position: "absolute",
                                left: "-17%",
                                top: "-17%",
                                "& .MuiCircularProgress-circle": {
                                    strokeLinecap: "round",
                                },
                                transform: "translate(-50%, -50%) rotate(-90deg)", // start from top
                            }}
                        /> */}
            <Avatar
              sx={{ width: 60, height: 60, bgcolor: '#d9d9d9' }}
              alt={loginUser?.first_name}
              src={loginUser?.profile_image}
            />
            {/* <Box
                            sx={{
                                position: "absolute",
                                bottom: -15,
                                left: "50%",
                                transform: "translateX(-50%)",
                                bgcolor: "white",
                                px: 1,
                                py: 0.2,
                                borderRadius: "12px",
                                border: "1px solid #008000",
                            }}
                        >
                            <Typography
                            variant="caption"
                            sx={{ fontSize: "0.7rem", fontWeight: 500 }}
                            >
                            75%
                            </Typography>
                        </Box> */}
          </Box>
          <Box sx={{ ml: 3 }}>
            <Typography
              variant='h1'
              mb={1}
              sx={{ textTransform: 'uppercase'}}
              // sx={{ fontSize: '20px' }}
            >
              {`${loginUser.first_name} ${loginUser.last_name}`}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Phone sx={{ fontSize: '13px' }} />
              <Typography
                variant='body1'
                sx={{ ml: 0.5 }}
              >
                {loginUser.phone_no}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <EmailOutlined sx={{ fontSize: '13px' }} />
              <Typography
                variant='body1'
                sx={{ ml: 0.5 }}
              >
                {loginUser.email}
              </Typography>
            </Box>
          </Box>
        </Box>
        {/* <Box>
                    <IconButton size="small">
                        <EditIcon fontSize="small" />
                    </IconButton>
                </Box> */}
      </Box>

      {is_PWA && (!addressDetails || addressDetails?.length === 0) ? null : (
        <DeliveryLocationCard
          onSetLocation={handleSetDeliveryLocation}
          addressDetails={addressDetails}
          fetchAddressDetails={handleAddressSaving}
          isPwa={is_PWA}
          companyEsiID={companyEsiId}
        />
      )}
      {loginUser && !is_PWA && isMobile && (
        <Grid container spacing={1}>
          <Grid item xs={6} md={4}>
              <Box sx={{ mb: 2 }}>
                <CustomSelect
                  size="small"
                  value={selectedCompany}
                  onChange={handleCompanyChange}
                  label="Firm"
                  fullWidth
                  disabled={decodedData?.all_companies_info?.length === 1}
                >
                  {decodedData?.all_companies_info?.map((company, idx, arr) => (
                    <MenuItem
                      key={company.company_id}
                      value={company.company_id}
                    >
                      {company.company_name}
                    </MenuItem>
                  ))}
                </CustomSelect>
              </Box>
          </Grid>
          <Grid item xs={6} md={4}>
            <Entity
              supplierLabel="Manufacturer"
              // entityLabel="SAP Code"
              gridSizes={{
                supplier: { xs: 12, sm: 12 },
                // entity: { xs: 12, sm: 4 }
              }}
              showManufacturerSelect={true}
              forceRefresh={false}
              showEntitySelect={false}
              autoFetch={false}
            />
          </Grid>
        </Grid>
      )}
      {visibleSections
        .map((section) => ({
          ...section,
          items: section.items.filter((item) => item.visible !== false), // keep only visible items
        }))
        .filter((section) => section.items.length > 0) // optional: skip sections with no visible items
        .map((section, idx) => (
          <Box
            key={idx}
            sx={{ mb: 3 }}
          >
            <Typography variant='h2'>{section.title}</Typography>
            <List>
              {section.items.map((item, i) => (
                <Box
                  key={i}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #D9D9D9',
                    py: 0.5,
                    cursor: 'pointer',
                  }}
                  onClick={() => navigate(item.path)}
                >
                  <Typography variant='labelD'>{item.label}</Typography>
                  <Box sx={{ width: 24, height: 24 , alignItems: 'center', display: 'flex' , justifyContent: 'center' }}>
                    <IconReusable name="ArrowRight" size={12} color='#333'/>
                  </Box>
                </Box>
              ))}
            </List>
          </Box>
        ))}

      {!is_PWA && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderBottom: '1px solid #D9D9D9',
            py: 0.5,
          }}
          onClick={handleLogout}
        >
          <Typography variant='h2'>Logout</Typography>
            <IconReusable name="LogoutOutlined" size={24} color='#333'/>
        </Box>
      )}

      <Box sx={{ textAlign: 'end', mt: 1 }}>
        <Typography
          variant='body1'
          sx={{ color: '#8c8c8c', mb: 2 }}
        >
          Version V2.02
        </Typography>
      </Box>
    </Box>
  );
};

export default Profile;
